import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'


const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const newMobileNumberWatch = () => {
  const newMobileNumberWatchRef = ref()
  const formStore = useFormStore()
  newMobileNumberWatchRef.value = watch(
    () => formStore.form.values.newMobileNumber,
    (newVal) => {
      if(newVal && formStore.form.values.currentMobileNumber == newVal) {
        
      doNotify(
        '',
        i18n.global.t('pleaseInsertDifferentMobileNumber'),
        undefined,
        'error'
      )
      formStore.form.setFieldValue('newMobileNumber', '')
      return
      }
      
    }
  )
  onUnmounted(() => {
    newMobileNumberWatchRef.value && newMobileNumberWatchRef.value()
  })
}
export default function () {
  return {
    newMobileNumberWatch
  }
}
